import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Mediterranean';
const DEFAULT_DESCRIPTION = 'Real Topics. Real People. A Sea of Conversations.';
const DEFAULT_IMAGE = '/mediterranean-clubhouse-preview-v3.png';
const DEFAULT_URL = 'https://mediterranean.studio';

const SEO = ({
  title = '',
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url = '/',
  type = 'website',
  article,
}) => {
  // Build title - ensure it's always a plain string
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const pageImage = image || DEFAULT_IMAGE;
  const fullUrl = `${DEFAULT_URL}${url}`;
  const fullImage = pageImage.startsWith('http') ? pageImage : `${DEFAULT_URL}${pageImage}`;

  // Set document title directly to avoid Helmet issues
  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return (
    <Helmet>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Article-specific */}
      {article && article.publishedTime && <meta property="article:published_time" content={article.publishedTime} />}
      {article && article.author && <meta property="article:author" content={article.author} />}
      {article && article.section && <meta property="article:section" content={article.section} />}
    </Helmet>
  );
};

export default SEO;
